export const metadataConfig = {
  title: "USGS | IWS Basin Data Explorer",
};

// always show the following layers (AOIs only for now)
export const staticLayers = ["ngwosBasins"];


export const aoiBasinMap = {
  "Illinois River Basin": [
    { category: "ngwos-basin", id: 10 },
    { category: "iwaas-basin", id: 10 },
  ],
  "Upper Colorado River Basin": [
    { category: "ngwos-basin", id: 8 },
    { category: "iwaas-basin", id: 8 },
  ],
  "Delaware River Basin": [
    { category: "ngwos-basin", id: 9 },
    { category: "iwaas-basin", id: 9 },
  ],
  "Willamette River Basin": [
    { category: "ngwos-basin", id: 4 },
    { category: "iwaas-basin", id: 4 },
  ],
  "Trinity-San Jacinto River Basin": [
    { category: "ngwos-basin", id: 5 },
  ],
};

export const lastSelectedLayerConfig = {
  layerId: "non-ngwos-project-sites",
};